<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">
            <x-form-group
                label="Tanggal"
                :error="getError('date')"
                :is-required="true"
            >
                <input
                    type="date"
                    class="form-control"
                    v-model="fields.date"
                    required
                />
            </x-form-group>

            <x-form-group
                label="Judul"
                :error="getError('name')"
                :is-required="false"
            >
                <input type="text" class="form-control" v-model="fields.name" />
            </x-form-group>

            <x-form-group
                label="Anomali"
                :error="getError('is_anomaly')"
                :is-required="false"
            >
                <x-checkbox-wrapper label="Tandai sebagai anomali">
                    <input
                        type="checkbox"
                        v-model="fields.is_anomaly"
                    />
                </x-checkbox-wrapper>
            </x-form-group>

            <x-form-group
                label="Data"
                :error="getError('values')"
                :is-required="true"
            >
                <x-table>
                    <tr v-for="(metric, index) in fields.values" :key="index">
                        <th>{{ metric.name }}</th>
                        <td>
                            <x-form-group
                                :error="getError(`values.${index}.value`)"
                                :is-required="false"
                            >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="metric.value"
                                />
                            </x-form-group>
                        </td>
                    </tr>
                </x-table>
            </x-form-group>

            <x-form-group
                label="Catatan"
                :error="getError('note')"
                :is-required="false"
            >
                <textarea class="form-control" v-model="fields.note" />
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XCheckboxWrapper from "../../components/XCheckboxWrapper.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XInputMetricCategory from "../../components/XInputMetricCategory.vue";
import XTable from "../../components/XTable.vue";
import { getCurrentDateStr } from "../../helpers";
import FormErrorMixin from "../../mixins/FormErrorMixin";

export default {
    components: {
        XFormGroup,
        XInputMetricCategory,
        XTable,
        XCheckboxWrapper,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
    },
    data() {
        return {
            fields: {
                date: getCurrentDateStr(),
                name: null,
                note: null,
                values: [],
            },
        };
    },
    methods: {
        handleSubmit() {
            this.$emit("submit", this.fields);
        },
    },
    mixins: [FormErrorMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
};
</script>